/* eslint-disable default-param-last */
export const types = {
  SEND_RETARGETING: "RETARGETING/SEND_RETARGETING",
  SUCCESS_RETARGETING: "RETARGETING/SUCCESS_RETARGETING",
  FAILURE_RETARGETING: "RETARGETING/FAILURE_RETARGETING",
};

export const actions = {
  sendRetargeting: (data) => ({
    type: types.SEND_RETARGETING,
    payload: { data },
  }),
  sendRetargetingSuccess: data => ({
    type: types.SUCCESS_RETARGETING,
    payload: data,
  }),
  sendRetargetingFailure: () => ({ type: types.FAILURE_RETARGETING }),
};

const initialState = {
  retargetingState: null,
};

function retargeting(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SEND_RETARGETING:
      return {
        ...state,
        retargetingState: 'FETCHING',
      };
    case types.SUCCESS_RETARGETING:
      return {
        ...state,
        retargetingState: 'SUCCESS',
      };
    case types.FAILURE_RETARGETING:
      return {
        ...state,
        retargetingState: 'FAILURE',
      };
    default:
      return state;
  }
}

export default retargeting;
